module.exports = __webpack_public_path__ + "img/平台专业服务p2.1a38af05.png";